import axios from "axios"
import request from "../utils/request"

/**
 * 图形验证码图片（需完整 response 以读取 header Captchatoken，不走会丢掉 headers 的 request 封装）
 */
export function getCaptcha() {
  return axios.get("https://api.incoinpay.net/anon/test/getCaptcha", {
    responseType: "blob",
    timeout: 15000,
  }).then((res) => {
    const h = res.headers || {}
    // axios/浏览器中 header 名多为小写；需服务端 CORS 暴露 Captchatoken 后前端才能读到
    const token = h.captchatoken || h.captchaToken
    return { blob: res.data, captchaToken: token }
  })
}

export function registerUser(userName,phoneNo,passwd,inviteCode,smsOtp,captcha,captchaToken,recaptchaToken) {
  return request({
//      url: 'https://api.incoinpay.net/anon/h5RegisterUser',
	url: 'https://api.incoinpay.net/anon/h5RegisterUser',
//   url: 'http://localhost:9902/anon/h5RegisterUser',
    method: 'post',
    headers:{
      "clientKey":"C4CA4238A0789C509A6F75849B",
      "appId":"xyz.indianx.app"
    },
    data:{
      "userName":userName,
      "phoneNo":phoneNo,
      "passwd":passwd,
      "inviteCode":inviteCode,
      "smsOtp":smsOtp,
      "captcha": captcha,
      "captchaToken": captchaToken,
      "reCaptcha": recaptchaToken
	  }
  })
}

export function sendVerCodeV2(userName,phoneNo,passwd,inviteCode,captcha,captchaToken,recaptchaToken) {
  return request({
//	url: 'https://api.incoinpay.net/anon/sendVerCodeV2',
	url: 'https://api.incoinpay.net/anon/sendVerCodeV2',
//    url: 'http://localhost:9902/anon/sendVerCodeV2',
    method: 'post',
    headers:{
      "clientKey":"C4CA4238A0789C509A6F75849B",
      "appId":"xyz.indianx.app"
    },
    data:{
      "userName":userName,
      "phoneNo":phoneNo,
      "passwd":passwd,
      "inviteCode":inviteCode,
      "captcha": captcha,
      "captchaToken": captchaToken,
      "reCaptcha": recaptchaToken
	  }
  })
}



